export const CATEGORYSEARCH = "blog/categorysearch";
export const AUTHORSEARCH = "blog/authorsearch";
export const GENERALSEARCH = "blog/generalsearch";
export const CLEARSEARCH = "blog/clearsearch";